import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { Category } from 'src/app/_models';

import { CategoryService } from 'src/app/_services/category.service';
import { first } from 'rxjs/operators';
import { DocumentService } from 'src/app/_services/document.services';
import { Document } from 'src/app/_models/document';

@Component({
  selector: 'app-update-document-title',
  templateUrl: './update-document-title.component.html',
  styleUrls: ['./update-document-title.component.scss']
})
export class UpdateDocumentTitleComponent implements OnInit {

  @Input() documentID: string;
  @Output() isUpdateDocumentTitle = new EventEmitter<boolean>();
  @Output() hideDocView = new EventEmitter<boolean>();
  @Output() catID = new EventEmitter<any>();
  @Output() catName = new EventEmitter<any>();

  uploadMessage: boolean = false
  propertyCols: String[];
  documentProp: String[];
  selectedHeader: number;
  propertiesValue: any;
  properties = {};
  categories: Category[];
  fetchedCategoryName: string;
  documentDetails: Document;
  categoryDetails: any;
  categoryNames = [];
  categoryID: any;
  categoryName: string;
  isMetaData: boolean = false
  category: Category
  searchCtrl: string = ""
  title:string=''
  constructor(
    private documentSvc: DocumentService,
    private categoryService: CategoryService
  ) { }

  ngOnInit() {
    this.uploadMessage = false
    this.categoryService.getAll().pipe(first()).subscribe(categories => {
      this.categories = categories['results'];
    });

    this.documentSvc.getDocumentDetails(this.documentID)
      .subscribe(details => {
        this.documentDetails = details;
        this.title=this.documentDetails.documentName
        this.categoryID = details.categoryId;
        this.documentProp = this.documentDetails.metadata.properties;
        this.propertyCols = Object.keys(this.documentDetails.metadata.properties);
        this.categoryService.get(this.categoryID).subscribe(category => {
          this.categoryDetails = category;
          this.categoryName = this.categoryDetails.name;
        });
      });
  }


  updateDocumentTitle(){
    var updateDocReq = {
      "docId": this.documentID,
      "title": this.title
    }
    this.documentSvc.updateDocumentTitle(updateDocReq).subscribe(resp => {
      this.uploadMessage = true
    })
  }

  back() {
    this.isUpdateDocumentTitle.emit(false);
    this.categoryService.getAll().pipe(first()).subscribe(categories => {
      this.categories = categories['results'];
    });

    this.documentSvc.getDocumentDetails(this.documentID)
      .subscribe(details => {
        this.documentDetails = details;
        this.categoryID = details.categoryId;
        this.documentProp = this.documentDetails.metadata.properties;
        this.propertyCols = Object.keys(this.documentDetails.metadata.properties);
        this.categoryService.get(this.categoryID).subscribe(category => {
          this.categoryDetails = category;
          this.categoryName = this.categoryDetails.name;
        });
      });
  }

}
